



















import Vue from 'vue';
import { ResourceLoader } from 'mycorems-app-shared';
import { Role } from '../types';
import RoleItem from './RoleItem.vue';
import repository from './role-repository';

interface Data {
  task: Promise<Role[]>|null,
  roles: Role[],
}

export default Vue.extend({
  components: {
    ResourceLoader,
    RoleItem,
  },
  props: {
    accountType: {
      type: Number,
      required: true,
    },
    value: String,
    serviceId: String,
    // Only show roles that are assignable by app user
    showAssignable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      task: null,
      roles: [],
    };
  },
  methods: {
    load() {
      this.task = repository.findAll(this.accountType, this.serviceId, this.showAssignable);
      this.task.then((roles) => {
        this.roles = roles;
      });
    },
    enable(role: Role) {
      this.$emit('enabled', role.id);
    },
    disable(role: Role) {
      this.$emit('disabled', role.id);
    },
    isEnabled(roleId: string): boolean {
      return (this.value === roleId);
    },
  },
  created() {
    this.load();
  },
});
